
import React from 'react'
import { Row, ContentColumn, CodeColumn } from '../../styles/utils'
import * as styles from './styles'

export default () => {
  return (
    <Row>
      <ContentColumn noPadding>
        <styles.Divider />
      </ContentColumn>
      <CodeColumn noPadding>
        <styles.Divider />
      </CodeColumn>
    </Row>
  )
}
